var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataprotection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 84,
    viewBox: "0 0 68 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1667 33.6668V21.1668C13.1667 15.6415 15.3617 10.3424 19.2687 6.43544C23.1757 2.52843 28.4747 0.333496 34.0001 0.333496C39.5254 0.333496 44.8245 2.52843 48.7315 6.43544C52.6385 10.3424 54.8334 15.6415 54.8334 21.1668V33.6668H59.0001C61.2102 33.6668 63.3298 34.5448 64.8926 36.1076C66.4554 37.6704 67.3334 39.79 67.3334 42.0002V75.3335C67.3334 77.5436 66.4554 79.6633 64.8926 81.2261C63.3298 82.7889 61.2102 83.6668 59.0001 83.6668H9.00008C6.78994 83.6668 4.67033 82.7889 3.10752 81.2261C1.54472 79.6633 0.666748 77.5436 0.666748 75.3335V42.0002C0.666748 39.79 1.54472 37.6704 3.10752 36.1076C4.67033 34.5448 6.78994 33.6668 9.00008 33.6668H13.1667ZM9.00008 42.0002V75.3335H59.0001V42.0002H9.00008ZM21.5001 33.6668H46.5001V21.1668C46.5001 17.8516 45.1831 14.6722 42.8389 12.328C40.4947 9.98379 37.3153 8.66683 34.0001 8.66683C30.6849 8.66683 27.5054 9.98379 25.1612 12.328C22.817 14.6722 21.5001 17.8516 21.5001 21.1668V33.6668ZM42.3334 50.3335H50.6667V67.0002H42.3334V50.3335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataprotection);
export default __webpack_public_path__ + "static/media/dataprotection.35e85762b8bfd1323ba3238f6ce6376c.svg";
export { ForwardRef as ReactComponent };